<template>
  <div class="third-login-box show-flex-box-c show-flex-center" @click.self="colseThirdLoginWin()" v-show="isThirdLogin">
    <div class="third-login-total show-flex-box-r show-flex-center" v-if="loginType != 'WX'">
      <div class="third-login-all show-flex-box-c">
        <!-- X图标 -->
        <em @click.self="colseThirdLoginWin()"></em>
        <dl class="third-login-content show-flex-box-c show-flex-center">
          <dt class="select-third-login-way show-flex-box-r">
            <ul class="select-third-login-way-list show-flex-box-r">
              <li class="select-third-login-way-item show-flex-box-c">
                <span>第三方扫码登录</span>
                <em></em>
              </li>
            </ul>
            <span @click.self="backLogin()">返回登录</span>
          </dt>
          <dd class="account-box show-flex-box-c show-flex-center" v-if="curThirdLoginType == 'weixin'">
            <span class="show-flex-box-r">
              <!-- <img src="../../assets/data_pic/erweima.png" alt=""> -->
               <wxlogin
                  :href="wxParams.href"
                  :state="wxParams.state"
                  :appid="wxParams.appid"
                  :scope="wxParams.scope"
                  :redirect_uri="wxParams.redirect_uri"
                ></wxlogin>
            </span>
            <em>请使用微信扫码登录</em>
          </dd>
        </dl>
      </div>
    </div>
    <div class="bind-phone show-flex-box-r">
      <bind-phone-pop
        ref="open_bind_phone_pop"
        :bindParams="bindParams"
        @open-set-password-pop="openSetPasswordPop"
      ></bind-phone-pop>
    </div>
    <div class="change-password show-flex-box-r">
      <set-password
        :hasPwd="hasPwd"
        @updata-bind-success="setPasswordSuccess"
        ref="open_change_password_pop"
      ></set-password>
    </div>
  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'
  import wxlogin from "vue-wxlogin";
  import regex from "@/filter/regex";
  import { CountDown } from "@/../static/js/CountDown";
  import bindPhonePop from "@/views/login/bind_phone";
  import setPassword from "@/views/login/set_password";

  // import {LoginUser} from "@/model/login_user.js";

  export default {
    name: "thirdLogin",
    data() {
      return {
        isThirdLogin: false,
         wxParams: {
          href:
            "data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKCi5vbGQtdGVtcGxhdGV7CiAgd2lkdGg6IDEwMCU7CiAgaGVpZ2h0OiAxMDAlOwp9CgouaW1wb3dlckJveHsKICB3aWR0aDogMTAwJTsKfQoKLmltcG93ZXJCb3ggLnRpdGxlewogIGRpc3BsYXk6IG5vbmU7Cn0KCi5pbXBvd2VyQm94IC5xcmNvZGV7CiAgd2lkdGg6IDEwMCU7CiAgYm9yZGVyOiBub25lOwogIG1hcmdpbi10b3A6IDA7Cn0KCi5pbXBvd2VyQm94IC5pbmZvewogIGRpc3BsYXk6IG5vbmU7Cn0=",
          state: "1216189",
          appid: "wx1f4593a55c29ab5f", // 注册申请的appid
          scope: "snsapi_login",
          redirect_uri: encodeURI('https://zgsftv.com/web/index?loginType="WX"')
          // redirect_uri: encodeURI('http://zgsftv.com/web/index?loginType="WX"')
        },
        loginType: "",
        bindParams: {},
        WXCode:"",
        hasPwd: true
      };
    },
    props: {
      curThirdLoginType: [String]
    },
    components: {
      wxlogin,
      bindPhonePop,
      setPassword
    },
    created() {
      this.loginType = this.$route.query.loginType || "";
      // this.checkIsThirdLogin();
    },
    mounted() {

    },
    methods: {
      colseThirdLoginWin: function() {
        this.isThirdLogin = !this.isThirdLogin;
      },
      checkIsThirdLogin: function() {
        if (this.loginType == "WX") {
        //   this.WXCode = this.$route.query.code || "";
        //   this.socialLogin();
          this.WXCode = '031b98Ga1r2k9C03soHa1dH5Dx4b98Gq';
          this.socialLogin();
        }
      },
      checkBindPhonePopDom: function() {
        if (!this.$refs.open_bind_phone_pop) {
          var _this = this;
          setTimeout(() => {
            _this.checkBindPhonePopDom();
          }, 300);
          return;
        }

        this.$refs.open_bind_phone_pop.colseLoginWin();
      },
      socialLogin: function() {
        this.isThirdLogin = true;
        this.bindParams.type = "weixin";
        this.bindParams.unionid = 'aaaaaaaaaaa';
        this.checkBindPhonePopDom();

        return;
        var params = {
          type: "weixin",
          code: this.WXCode
        };

        this.$client
          .socialLogin(params)
          .then(res => {
            if (res.code == 200) {
              var userToken = res.data.token;
              alert(userToken)
              if (userToken) {
                this.loginSucceed(userToken);
              } else {
                this.bindParams.type = "weixin";
                this.bindParams.unionid = res.data.authUserInfo.unionid;
                this.checkBindPhonePopDom();
              }
            }
          })
          .catch(err => {
            this.$router.back(-1);
          });
      },
      loginSucceed: function(token) {
        let saveTokenObj = {
          token: token
        };
        this.$store.commit("SET_TOKEN", saveTokenObj);
        this.$store.commit("LOGIN", true); //登录成功后改变登录状态
        this.$router.push({ path: "/web/index" });
        this.reload();
      },
      openSetPasswordPop: function(bln) {
        this.hasPwd = bln;
        this.$refs.open_change_password_pop.colseSetPasswordWin();
      },
      setPasswordSuccess: function() {
        this.$router.push({ path: "/web/index" });
        this.reload();
      },
      backLogin: function() {
        this.$parent.$refs.login.colseLoginWin();
        this.isThirdLogin = false;
      }

    }
  };

</script>
<style lang="less" scoped>
  .third-login-box{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: rgba(0, 0, 0, 0.4);
    .third-login-total{
      width:560px;
      padding: 30px 0px 60px 0px;
      background:#FFFFFF;
      border-radius:8px;
      position: absolute;
      .third-login-all{
        width: 506px;
        height: 100%;
        align-items: flex-end;
        padding-left: 22px;
        >em{
          display: block;
          width: 22px;
          height: 22px;
          background: url("../../assets/login/close_arrow_icon.png") no-repeat center center;
          background-size: 22px 22px;
          margin-bottom: 18px;
          flex-shrink: 0;
          cursor: pointer;
        }
        >dl{
          width: 100%;
          align-items: center;
          >dt{
            width: 400px;
            padding-right: 23px;
            align-items: flex-end;
            margin-bottom: 30px;
            >ul{
              width: 100%;
              align-items: center;
              >li{
                align-items: center;
                margin-right: 25px;
                cursor: default;
                >span{
                  font-size:24px;
                  font-family:PingFangSC-Regular,PingFang SC;
                  font-weight:400;
                  color:#333333;
                  line-height:33px;
                  white-space: nowrap;
                  flex-shrink: 0;
                  margin-bottom: 5px;
                }
               >em{
                  width:35px;
                  height:5px;
                  background:#CB1309;
                  border-radius:3px;
               }

              }
            }
            >span{
              font-size:15px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:#333333;
              line-height:21px;
              white-space: nowrap;
              flex-shrink: 0;
              margin-bottom: 10px;
              cursor: pointer;
            }
          }
          .account-box{
            width: 100%;
            width: 400px;
            >span{
              display: block;
              width: 300px;
              height: 300px;
              margin-bottom: 15px;
              flex-shrink: 0;
              >img{
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
              }
            }
            >em{
              text-align: center;
              font-size:13px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:#666666;
              line-height:19px;
              white-space: normal;
            }
          }
        }
      }
    }

  }

</style>




// WEBPACK FOOTER //
// src/views/login/third_code_login.vue